export default from './back-button';



// WEBPACK FOOTER //
// ./app/containers/back-button/index.js